import i18n, { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { Panel } from 'config/app';
import { env } from 'config/env';

import { langStore } from './config';

import es from './translations/es.json';
import en from './translations/en.json';
import pt from './translations/pt.json';

const langs: Record<Panel, string> = {
  voceopina: 'pt-BR',
  quedices: 'es',
  queopinas: 'es',
};

const saved = langStore.lang.get();

const lang = saved || langs[env.appId];

use(initReactI18next).init({
  lng: lang,
  fallbackLng: lang,

  ns: ['translations'],
  defaultNS: 'translations',

  resources: {
    'pt-BR': {
      translations: pt,
    },

    es: {
      translations: es,
    },

    en: {
      translations: en,
    },
  },
});

i18n.languages = Object.values(langs);

export default i18n;
